// Advertised "Subscribe & Save 10%". StayAI selling-plan options report a
// 0% price adjustment, so we floor the displayed subscription price at this
// discount off the regular price to match the offer shown to customers.
const SUB_INTERVAL_DISCOUNT_RATE = 0.1;

// Press feedback for the flavor-card quantity pill: tip it 5° toward the tapped
// control, pivoting on that side (transform-origin moves to the pressed edge). The
// CSS keyframes live in blocks/lsg-flavor-picker.liquid.
function playQtyTilt(trigger) {
  const wrap = trigger.closest(".lsg-bundle-product-select-quantity-wrap");
  if (!wrap) return;
  const cls = trigger.classList.contains(
    "lsg-bundle-product-select-quantity-minus",
  )
    ? "lsg-qty-tilt-minus"
    : "lsg-qty-tilt-plus";
  wrap.classList.remove("lsg-qty-tilt-minus", "lsg-qty-tilt-plus");
  // Restart the animation when the control is tapped again mid-tilt.
  void wrap.offsetWidth;
  wrap.classList.add(cls);
  wrap.addEventListener("animationend", () => wrap.classList.remove(cls), {
    once: true,
  });
}

let productSelectionButtonClicked = false,
  productSelectionIndex,
  selectedProducts = [];
document.querySelectorAll(".lsg-bundle-block").forEach(() => {
  selectedProducts.push([]);
});

const buildSelectedProductArray = (trigger) => {
  const method = trigger.classList.contains(
    "lsg-bundle-product-select-quantity-minus",
  )
    ? "minus"
    : trigger.classList.contains("lsg-bundle-product-select-quantity-plus")
      ? "plus"
      : "err";
  const triggeredProductWrapper = trigger.closest(
    ".lsg-bundle-product-select-wrapper",
  );
  const variantID = triggeredProductWrapper.getAttribute(
    "data-lsg-bundle-variant-select-id",
  );
  const productTitle = triggeredProductWrapper
    .querySelector(".lsg-bundle-product-select-title")
    .textContent.trim();
  const bundleBlock = getBundleBlock(trigger);
  const bundleIndex0 = getBundleBlockIndex0(bundleBlock);
  // The per-block selection buckets are seeded once from the .lsg-bundle-block count at script load.
  // In the product-information composition the block is marked later (by the adapter), so seed the
  // bucket lazily here to avoid "undefined.push/splice".
  if (!selectedProducts[bundleIndex0]) {
    selectedProducts[bundleIndex0] = [];
  }

  switch (method) {
    case "minus":
      if (productSelectionButtonClicked == true) {
        selectedProducts[bundleIndex0].splice(productSelectionIndex, 1);
        productSelectionButtonClicked = false;
      } else {
        productSelectionIndex = selectedProducts[bundleIndex0].findLastIndex(
          (p) => p.selectedVariantId == variantID,
        );
        selectedProducts[bundleIndex0].splice(productSelectionIndex, 1);
      }
      break;
    case "plus":
      const selectedImgUrl = triggeredProductWrapper.getAttribute(
        "data-lsg-bundle-variant-selected-img",
      );
      const selectedImgAlt = triggeredProductWrapper.getAttribute(
        "data-lsg-bundle-variant-selected-img-alt",
      );
      const flavorImgUrl = triggeredProductWrapper.getAttribute(
        "data-lsg-bundle-variant-flavor-img",
      );
      const flavorImgAlt = triggeredProductWrapper.getAttribute(
        "data-lsg-bundle-variant-flavor-img-alt",
      );
      const mainRowImg = triggeredProductWrapper.querySelector(
        ".lsg-bundle-product-select-img-wrap img",
      );
      const productImageUrl =
        selectedImgUrl && selectedImgUrl.trim()
          ? selectedImgUrl
          : flavorImgUrl && flavorImgUrl.trim()
            ? flavorImgUrl
            : mainRowImg
              ? mainRowImg.src
              : "";
      const productImageAlt =
        selectedImgAlt && selectedImgAlt.trim()
          ? selectedImgAlt
          : flavorImgAlt && flavorImgAlt.trim()
            ? flavorImgAlt
            : mainRowImg
              ? mainRowImg.alt
              : "";
      const variantBg =
        triggeredProductWrapper.getAttribute("data-lsg-bundle-variant-bg") ||
        "";
      const variantFg =
        triggeredProductWrapper.getAttribute("data-lsg-bundle-variant-fg") ||
        "";
      let selectedProductData = {
        selectedProductImageUrl: productImageUrl,
        selectedVariantId: variantID,
        selectedProductTitle: productTitle,
        selectedProductImageAlt: productImageAlt,
        selectedVariantBg: variantBg,
        selectedVariantFg: variantFg,
      };
      selectedProducts[bundleIndex0].push(selectedProductData);
      break;
  }
  updateSelectedProductGUI(trigger);
};

// The "active line" prefix (e.g. "8 × ") is a section setting (288-stay-ai-overrides › active line
// before). It's published as a CSS var so it can be prepended to the flavor name as REAL text here —
// part of the title string — instead of a ::before pseudo. Cached after first read.
let _activeLinePrefix = null;
function getActiveLinePrefix() {
  if (_activeLinePrefix !== null) return _activeLinePrefix;
  let v = getComputedStyle(document.documentElement)
    .getPropertyValue("--lsg-active-line-prefix")
    .trim();
  if (v.startsWith('"') && v.endsWith('"')) v = v.slice(1, -1);
  // Exactly one trailing space before the flavor name (the CSS var loses a trailing space).
  v = v.replace(/\s+$/, "");
  if (v) v += " ";
  _activeLinePrefix = v;
  return v;
}

const updateSelectedProductGUI = (trigger) => {
  const bundleBlock = getBundleBlock(trigger);
  const bundleIndex0 = getBundleBlockIndex0(bundleBlock);
  if (selectedProducts[bundleIndex0].length > 0) {
    bundleBlock.classList.add("has-selected-product");
  } else {
    bundleBlock.classList.remove("has-selected-product");
  }

  const selectedProductsWrappers = bundleBlock.querySelectorAll(
    "[data-bundle-builder-selected-products]",
  );
  selectedProductsWrappers.forEach((selectedProductsWrapper) => {
    const selectedProductWrappers = selectedProductsWrapper.querySelectorAll(
      "[data-bundle-builder-selected-variant-id]",
    );

    selectedProductWrappers.forEach((productWrapper, i) => {
      const selectedProductData = selectedProducts[bundleIndex0][i];

      const productWrapperImage = productWrapper.querySelector(
        "[data-bundle-builder-selected-product-image]",
      );
      const productWrapperTitle = productWrapper.querySelector(
        "[data-bundle-builder-selected-product-title]",
      );

      if (typeof selectedProductData !== "undefined") {
        productWrapper.setAttribute(
          "data-bundle-builder-selected-variant-id",
          selectedProductData.selectedVariantId,
        );

        productWrapperImage.src = selectedProductData.selectedProductImageUrl;
        productWrapperImage.alt = selectedProductData.selectedProductImageAlt;

        productWrapperTitle.innerHTML =
          getActiveLinePrefix() + selectedProductData.selectedProductTitle;

        const bg =
          selectedProductData.selectedVariantBg &&
          selectedProductData.selectedVariantBg.trim();
        const fg =
          selectedProductData.selectedVariantFg &&
          selectedProductData.selectedVariantFg.trim();
        if (bg) {
          productWrapper.style.setProperty("--lsg-bundle-variant-bg", bg);
        } else {
          productWrapper.style.removeProperty("--lsg-bundle-variant-bg");
        }
        if (fg) {
          productWrapper.style.setProperty("--lsg-bundle-variant-fg", fg);
        } else {
          productWrapper.style.removeProperty("--lsg-bundle-variant-fg");
        }

        productWrapper.classList.add("active");
      } else {
        productWrapper.setAttribute(
          "data-bundle-builder-selected-variant-id",
          "",
        );

        productWrapperImage.src = "";
        productWrapperImage.alt = "";

        productWrapperTitle.innerHTML = "";

        productWrapper.style.removeProperty("--lsg-bundle-variant-bg");
        productWrapper.style.removeProperty("--lsg-bundle-variant-fg");

        productWrapper.classList.remove("active");
      }
    });

    scrollSelectedProductsToNextEmpty(selectedProductsWrapper);
  });

  updateStickyBundleCount(bundleBlock);
};

/**
 * @param {HTMLElement} bundleBlock
 */
function updateStickyBundleCount(bundleBlock) {
  if (!bundleBlock) return;

  const quantity = Math.max(0, getBundleQuantity(bundleBlock));
  const interval = getBundleInterval(bundleBlock);
  const max =
    interval == "otp"
      ? bundleBlock.dataset.otpBundleMax
      : bundleBlock.dataset.subBundleMax;

  bundleBlock
    .querySelectorAll(".lsg-bundle-sticky-summary-band__count-current")
    .forEach((countEl) => {
      countEl.textContent = String(quantity);
    });

  bundleBlock
    .querySelectorAll(".lsg-bundle-sticky-summary-band__count-max")
    .forEach((maxEl) => {
      if (max) maxEl.textContent = max;
    });
}

const scrollSelectedProductsToNextEmpty = (selectedProductsWrapper) => {
  if (!window.matchMedia("(max-width: 749px)").matches) return;

  const grid = selectedProductsWrapper.querySelector(
    ".bundle-builder__selected-products-grid",
  );
  if (!grid || grid.scrollWidth <= grid.clientWidth) return;

  const target =
    grid.querySelector(".bundle-builder__selected-product:not(.active)") ||
    grid.querySelector(".bundle-builder__selected-product.active:last-of-type");

  if (!target) return;

  requestAnimationFrame(() => {
    const targetRight = target.offsetLeft + target.offsetWidth;
    const scrollLeft = Math.max(0, targetRight - grid.clientWidth + 24);
    smoothScrollGridTo(grid, scrollLeft);
  });
};

/**
 * Gentle eased horizontal scroll for the mobile selected-products row. Native
 * `scrollTo({ behavior: "smooth" })` snaps too fast / feels aggressive when a flavor is added or
 * removed, so glide over a longer ease-out curve instead. Falls back to an instant jump under
 * reduced-motion.
 * @param {HTMLElement} grid
 * @param {number} to target scrollLeft
 */
function smoothScrollGridTo(grid, to) {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    grid.scrollLeft = to;
    return;
  }
  const from = grid.scrollLeft;
  const delta = to - from;
  if (Math.abs(delta) < 1) return;

  // Cancel any in-flight glide on this grid so rapid add/remove doesn't stack animations.
  if (grid._lsgScrollRAF) cancelAnimationFrame(grid._lsgScrollRAF);

  const duration = 550;
  const easeOut = (t) => 1 - Math.pow(1 - t, 3);
  let start = null;
  const step = (ts) => {
    if (start === null) start = ts;
    const t = Math.min(1, (ts - start) / duration);
    grid.scrollLeft = from + delta * easeOut(t);
    if (t < 1) {
      grid._lsgScrollRAF = requestAnimationFrame(step);
    } else {
      grid._lsgScrollRAF = null;
    }
  };
  grid._lsgScrollRAF = requestAnimationFrame(step);
}

// Time (ms) the slot-removal animation runs before the real decrement/re-render. Kept slightly
// longer than the CSS transition so the row has fully settled (mobile collapse) before re-render.
const LSG_SLOT_REMOVE_MS = 360;

/**
 * Animate the removal of a single selected-flavor slot: the tile at `index` scales down and — on
 * mobile — collapses its footprint so the rest of the row slides in to fill the gap, all in one
 * soft transition. Runs `done()` (the real decrement/re-render) once the animation has played.
 * Honors reduced-motion and falls back to an immediate `done()` when there's nothing to animate.
 * @param {HTMLElement} bundleBlock
 * @param {number} index slot index (matches the tile's data-index, shared across all summaries)
 * @param {() => void} done
 */
function animateBundleSlotRemoval(bundleBlock, index, done) {
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (!bundleBlock || index == null || index < 0 || reduced) {
    done();
    return;
  }
  const tiles = bundleBlock.querySelectorAll(
    `[data-bundle-builder-selected-products] .bundle-builder__selected-product[data-index="${index}"].active`,
  );
  if (!tiles.length) {
    done();
    return;
  }
  tiles.forEach((t) => t.classList.add("lsg-slot-removing"));
  setTimeout(function () {
    tiles.forEach((t) => t.classList.remove("lsg-slot-removing"));
    done();
  }, LSG_SLOT_REMOVE_MS);
}

function getBundleMax(bundleBlock) {
  const interval = getBundleInterval(bundleBlock);
  const max =
    interval == "otp"
      ? bundleBlock.dataset.otpBundleMax
      : bundleBlock.dataset.subBundleMax;

  return parseInt(max, 10) || 0;
}

function syncSelectedProductsToBundleInputs(bundleBlock) {
  const bundleIndex0 = getBundleBlockIndex0(bundleBlock);
  const selectedProductCounts = {};

  selectedProducts[bundleIndex0].forEach((selectedProduct) => {
    selectedProductCounts[selectedProduct.selectedVariantId] =
      (selectedProductCounts[selectedProduct.selectedVariantId] || 0) + 1;
  });

  const picker = getSharedPicker(bundleBlock);
  if (picker) {
    picker
      .querySelectorAll(".lsg-bundle-product-select-quantity-input")
      .forEach((input) => {
        input.value = selectedProductCounts[input.dataset.product] || 0;
        updateQuantityDisplay(input);
      });

    const firstQtyInput = picker.querySelector(
      ".lsg-bundle-product-select-quantity-input",
    );
    if (firstQtyInput) {
      incrementEnableValidation(firstQtyInput);
    }
  }

  checkoutEnableValidation(bundleBlock);
  updateBundlePrice(bundleBlock);
}

function carrySelectedProductsToBundle(sourceBundle, targetBundle) {
  if (!sourceBundle || !targetBundle || sourceBundle === targetBundle) return;

  const sourceIndex0 = getBundleBlockIndex0(sourceBundle);
  const targetIndex0 = getBundleBlockIndex0(targetBundle);
  const targetMax = getBundleMax(targetBundle);
  const nextSelectedProducts = selectedProducts[sourceIndex0].map((product) => ({
    ...product,
  }));

  const carriedProducts =
    targetMax > 0
      ? nextSelectedProducts.slice(0, targetMax)
      : nextSelectedProducts;

  selectedProducts[targetIndex0] = carriedProducts;

  syncSelectedProductsToBundleInputs(targetBundle);
}

function setActiveBundle(trigger) {
  //sets different bundle blocks active
  const bundleIndex = trigger.dataset.bundleIndex;
  const bundleWrapper = trigger.closest(".lsg-bundle-wrapper");
  const bundleBlocks = bundleWrapper.querySelectorAll(".lsg-bundle-block");
  const activeBundle = bundleWrapper.querySelector(
    ".lsg-bundle-block.lsg-bundle-block-active",
  );
  const targetBundle = bundleWrapper.querySelector(
    '[data-bundle-index="' + bundleIndex + '"].lsg-bundle-block',
  );
  if (targetBundle) {
    syncSharedPickerMax(targetBundle);
    carrySelectedProductsToBundle(activeBundle, targetBundle);

    bundleBlocks.forEach(function (bundleBlock) {
      if (bundleBlock.dataset.bundleIndex != bundleIndex) {
        bundleBlock.classList.remove("lsg-bundle-block-active");
      } else {
        bundleBlock.classList.add("lsg-bundle-block-active");
      }
    });
    // The now-visible block's "2-line" titles were display:none at load (unmeasurable), so balance
    // them synchronously here — same tick as the show, before paint — to avoid a 1→2 line flash.
    document.dispatchEvent(new Event("text-balance:rerun"));
    updateSelectedProductGUI(targetBundle);
    syncAllTierDiscounts();
    bundleBlocks.forEach(function (bb) {
      updateBundlePrice(bb);
    });
    setUrl(targetBundle.querySelector("form"));
  }
}

function checkParameter() {
  const urlParams = new URLSearchParams(window.location.search);
  const bundleBlocks = document.querySelectorAll(".lsg-bundle-block");
  const queryString = window.location.search;
  const bundles = urlParams.getAll("bundle");
  let bundle_index = urlParams.getAll("bundle_index");
  const bundle_interval = urlParams.getAll("bundle_interval");
  const bundle_interval_frequency = urlParams.getAll(
    "bundle_interval_frequency",
  );
  if (
    bundles.length > 0 ||
    urlParams.has("bundle_index") ||
    urlParams.has("bundle_interval") ||
    urlParams.has("bundle_interval_frequency")
  ) {
    if (bundle_index.length > 0) {
      bundle_index = bundle_index[0];
    } else {
      bundle_index = 0;
    }
    if (isNaN(bundle_index)) {
      bundle_index = 0;
    }
    if (bundleBlocks.length < bundle_index) {
      bundle_index = 0;
    }
    const bundleBlock = bundleBlocks[bundle_index];
    if (bundle_index > 0) {
      const bundleBlockSelects = document.querySelectorAll(
        ".lsg-bundle-size-select .lsg-bundle-size-select-el",
      );
      bundleBlockSelects[bundle_index].click();
    }

    bundles.forEach((el) => {
      const item = el.split("_");
      const id = item[0];
      const quantity = item[1];
      const cpPicker = getSharedPicker(bundleBlock);
      const quantityInput = cpPicker
        ? cpPicker.querySelector(
            `.lsg-bundle-product-select-quantity-input[data-product="${id}"]`,
          )
        : null;

      if (quantityInput != null) {
        quantityInput.value = parseInt(quantity, 10) - 1;
        const quantityInputPlus = quantityInput
          .closest(".lsg-bundle-product-select-quantity-wrap")
          .querySelector(`.lsg-bundle-product-select-quantity-plus`);

        for (let i = 0; i < quantity; i++) {
          quantityInput.value = i;
          incrementSubProduct(quantityInputPlus);
          buildSelectedProductArray(quantityInputPlus);
          incrementEnableValidation(quantityInputPlus);
          checkoutEnableValidation(quantityInputPlus);
        }
        // selectedProductsPlaceholderManager();
      }
    });
    bundle_interval.forEach((el) => {
      const packSizeSelectorItem = bundleBlock.querySelector(
        `.lsg-bundle-interval-select input[name^="bundle_interval_select_"][value="${bundle_interval}"]`,
      );
      if (packSizeSelectorItem != null) {
        packSizeSelectorItem.checked = true;
        updateInterval(packSizeSelectorItem);
        checkoutEnableValidation(packSizeSelectorItem);
      }
    });
    bundle_interval_frequency.forEach((el) => {
      const bundleIntervalFrequencySelect = bundleBlock.querySelector(
        ".lsg-bundle-interval-frequency-select",
      );
      if (bundleIntervalFrequencySelect != null) {
        bundleIntervalFrequencySelect.value = bundle_interval_frequency;
        updateFrequency(bundleIntervalFrequencySelect);
      }
    });
    if (history.pushState) {
      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        queryString;
      window.history.pushState({ path: newurl }, "", newurl);
    }
  }
}

function setUrl(trigger) {
  const bundleBlockWrapper = trigger.closest(".lsg-bundle-wrapper");
  if (
    bundleBlockWrapper &&
    !bundleBlockWrapper.hasAttribute("data-lsg-bundle-set-url")
  ) {
    return false;
  }
  const bundleBlock = getBundleBlock(trigger);
  const sharedPicker = getSharedPicker(bundleBlock);
  const quantityInput = sharedPicker
    ? sharedPicker.querySelectorAll(".lsg-bundle-product-select-quantity-input")
    : [];
  let url = "?";
  let paramName = "bundle";
  quantityInput.forEach((el) => {
    const value = el.value;
    if (value > 0) {
      url += url == "?" ? "" : "&";
      url += `${paramName}=${el.getAttribute("data-product")}_${value}`;
    }
  });
  const selectedBundle = bundleBlock
    .closest(".lsg-bundle-wrapper")
    .querySelector(".lsg-bundle-block.lsg-bundle-block-active");
  if (selectedBundle != null) {
    paramName = "bundle_index";
    url += url == "?" ? "" : "&";
    url += `${paramName}=${getBundleBlockIndex0(selectedBundle)}`;
  }
  const bundleIntervalOption = bundleBlock.querySelector(
    '.lsg-bundle-interval-select input[type="radio"]:checked',
  );
  if (bundleIntervalOption != null) {
    paramName = "bundle_interval";
    url += url == "?" ? "" : "&";
    url += `${paramName}=${bundleIntervalOption.value}`;
    if (bundleIntervalOption.value == "sub") {
      paramName = "bundle_interval_frequency";
      url += url == "?" ? "" : "&";
      const bundleIntervalFrequencySelect = bundleBlock.querySelector(
        ".lsg-bundle-interval-frequency-select",
      );
      if (bundleIntervalFrequencySelect != null) {
        url += `${paramName}=${bundleIntervalFrequencySelect.value}`;
      }
    }
  }
  if (history.pushState) {
    var newurl =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname +
      url;
    window.history.pushState({ path: newurl }, "", newurl);
  }
}

function incrementEnableValidation(trigger) {
  //trigger is input or increment buttons
  const productSetList = trigger.closest(".lsg-bundle-product-set-list");
  const quantityIncrementButtons = productSetList.querySelectorAll(
    ".lsg-bundle-product-select-quantity-increment",
  );
  const bundleQuantity = getBundleQuantityByChild(trigger);
  const bundleMax = productSetList.dataset.bundleMax;

  //increment button enable/disable
  quantityIncrementButtons.forEach(function (quantityIncrementButton) {
    const method = quantityIncrementButton.classList.contains(
      "lsg-bundle-product-select-quantity-minus",
    )
      ? "minus"
      : quantityIncrementButton.classList.contains(
            "lsg-bundle-product-select-quantity-plus",
          )
        ? "plus"
        : "err";
    const input = quantityIncrementButton
      .closest(".lsg-bundle-product-select-quantity-wrap")
      .querySelector(".lsg-bundle-product-select-quantity-input");
    const quantity = input.value;
    switch (method) {
      case "minus":
        quantityIncrementButton.disabled = false;
        if (quantity <= 0) {
          quantityIncrementButton.disabled = true;
        }
        if (quantity <= parseInt(input.min)) {
          quantityIncrementButton.disabled = true;
        }
        break;
      case "plus":
        // Out-of-stock variants (0/null inventory) are flagged server-side and
        // must never be re-enabled, regardless of quantity/bundle state.
        if (quantityIncrementButton.dataset.lsgBundleOutOfStock === "true") {
          quantityIncrementButton.disabled = true;
          break;
        }
        quantityIncrementButton.disabled = false;
        // Treat a missing/invalid max as 0 so out-of-stock variants (0 or null
        // inventory) keep the add button disabled instead of NaN slipping through.
        if (quantity >= (parseInt(input.max) || 0)) {
          quantityIncrementButton.disabled = true;
        }
        if (parseInt(bundleMax) > 0) {
          if (bundleQuantity >= parseInt(bundleMax)) {
            quantityIncrementButton.disabled = true;
          }
        }
        break;
    }
  });
}

function checkoutEnableValidation(trigger) {
  const bundleBlock = getBundleBlock(trigger);
  const addToCartButtons = bundleBlock.querySelectorAll("[data-lsg-bundle-atc");
  const bundleQuantity = getBundleQuantity(trigger);
  const interval = getBundleInterval(trigger);
  const bundleMin =
    interval == "otp"
      ? bundleBlock.dataset.otpBundleMin
      : bundleBlock.dataset.subBundleMin;
  const bundleMax =
    interval == "otp"
      ? bundleBlock.dataset.otpBundleMax
      : bundleBlock.dataset.subBundleMax;
  const quantityToAdd = bundleMin - bundleQuantity;

  //checkout button enable/disable
  addToCartButtons.forEach(function (addToCartButton) {
    const addToCartText = addToCartButton.querySelector(
      "[data-lsg-bundle-submit-button-atc-text]",
    );
    const addMoreText = addToCartButton.querySelector(
      "[data-lsg-bundle-submit-button-add-more-text]",
    );
    const addMoreQuantity = addToCartButton.querySelector(
      "[data-lsg-bundle-submit-button-add-more-quantity]",
    );

    if (
      bundleQuantity >= bundleMin &&
      (bundleQuantity <= bundleMax || bundleMax < bundleMin)
    ) {
      addToCartButton.classList.remove("disabled");
      addToCartText.classList.remove("hidden");
      addMoreText.classList.add("hidden");
      bundleBlock.classList.add("bundle-checkout-enabled");
    } else {
      addToCartButton.classList.add("disabled");
      addToCartText.classList.add("hidden");
      addMoreText.classList.remove("hidden");
      addMoreQuantity.innerHTML = quantityToAdd;
      bundleBlock.classList.remove("bundle-checkout-enabled");
    }
  });

  updateStickyBundleCount(bundleBlock);
}

function getBundleBoxCount(bundleBlock) {
  if (!bundleBlock) return "";
  let label = (bundleBlock.dataset.bundleSizeLabel || "").trim();
  if (!label) {
    const wrapper = bundleBlock.closest(".lsg-bundle-wrapper");
    const selectedTitle = wrapper
      ? wrapper.querySelector(
          ".lsg-bundle-size-select-el--selected .lsg-bundle-size-select-el__title",
        )
      : null;
    label = selectedTitle ? (selectedTitle.textContent || "").trim() : "";
  }
  const match = label.match(/(\d+)/);
  return match ? match[1] : "";
}

function addToCart(trigger) {
  const bundleID = getGuid();
  const bundleBlock = getBundleBlock(trigger);
  const bundleForm = bundleBlock.querySelector(".lsg-bundle-form");
  const bundleProductID = bundleForm.querySelector('input[name="id"]').value;
  const bundleSellingPlan = bundleForm.querySelector(
    'input[name="selling_plan"]',
  ).value;
  const interval = bundleSellingPlan == "" ? "otp" : "sub";
  const bundleMin =
    interval == "otp"
      ? bundleBlock.dataset.otpBundleMin
      : bundleBlock.dataset.subBundleMin;
  const bundleMax =
    interval == "otp"
      ? bundleBlock.dataset.otpBundleMax
      : bundleBlock.dataset.subBundleMax;
  const bundleProductList = getSharedPicker(bundleBlock);
  const bundleProductListInputs = bundleProductList
    ? bundleProductList.querySelectorAll(
        ".lsg-bundle-product-select-quantity-input",
      )
    : [];
  let bundleCart = {
    items: [],
  };
  let bundleProductQuantity = 0;
  const childLineItems = [];

  bundleProductListInputs.forEach(function (bundleProductInput) {
    const qty = parseInt(bundleProductInput.value, 10) || 0;
    bundleProductQuantity += qty;
    if (qty > 0) {
      childLineItems.push({
        id: bundleProductInput.dataset.product,
        quantity: qty,
      });
    }
  });

  {
    const properties = {
      bundle_id: bundleID,
      bundle_parent: true,
    };
    const bundleBoxes = getBundleBoxCount(bundleBlock);
    if (bundleBoxes) {
      properties.bundle_boxes = bundleBoxes;
    }
    let cartItem = {
      id: bundleProductID,
      quantity: 1,
      properties: properties,
    };
    if (interval == "sub") {
      cartItem["selling_plan"] = bundleSellingPlan;
    }
    bundleCart.items.push(cartItem);
  }
  childLineItems.forEach(function (child) {
    let cartItem = {
      id: child.id,
      quantity: child.quantity,
      properties: {
        bundle_id: bundleID,
      },
    };
    if (interval == "sub") {
      cartItem["selling_plan"] = bundleSellingPlan;
    }
    bundleCart.items.push(cartItem);
  });
  if (bundleProductQuantity > bundleMax || bundleProductQuantity < bundleMin) {
    //quantity is not within bundle size
    return false;
  }

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify(bundleCart),
    credentials: "same-origin",
  })
    .then((response) => {
      if (response.status == 200) {
        if (
          window.Rebuy &&
          window.Rebuy.SmartCart &&
          typeof window.Rebuy.SmartCart.show === "function"
        ) {
          window.Rebuy.SmartCart.show();
        }
      }
    })
    .catch((error) => {
      console.error(error);
    });
}

function updateFrequency(trigger) {
  //Render price and assign selling_plan in the form
  updateBundlePrice(trigger);
  updateSellingPlan(trigger);
}

function updateInterval(trigger) {
  //updates bundle block classes, resets displayed prices, and sets the selling_plan input value
  const bundleBlock = getBundleBlock(trigger);
  const sellingPlanInput = bundleBlock.querySelector(
    '.lsg-bundle-form input[name="selling_plan"]',
  );
  const frequencySelect = bundleBlock.querySelector(
    ".lsg-bundle-interval-frequency-select:not(.is-duplicate)",
  );

  switch (trigger.value) {
    case "otp":
      bundleBlock.classList.remove("lsg-bundle--sub-selected");
      bundleBlock.classList.add("lsg-bundle--otp-selected");
      if (sellingPlanInput) {
        sellingPlanInput.value = "";
      }
      break;
    case "sub":
      bundleBlock.classList.remove("lsg-bundle--otp-selected");
      bundleBlock.classList.add("lsg-bundle--sub-selected");
      if (sellingPlanInput) {
        sellingPlanInput.value = frequencySelect ? frequencySelect.value : "";
      }
      break;
  }

  updateBundlePrice(trigger);
  updateSellingPlan(trigger);
}

function updateSellingPlan(trigger) {
  //set form selling_plan based on selected state
  const bundleBlock = getBundleBlock(trigger);
  const selling_plan = bundleBlock.querySelector(
    '.lsg-bundle-form input[name="selling_plan"]',
  );
  if (selling_plan) {
    if (
      bundleBlock.classList.contains("lsg-bundle--sub-selected") ||
      bundleBlock.classList.contains("lsg-bundle--only-sub")
    ) {
      const frequencySelect = bundleBlock.querySelector(
        ".lsg-bundle-interval-frequency-select:not(.is-duplicate)",
      );
      if (frequencySelect) {
        selling_plan.value = frequencySelect.value;
      } else {
        selling_plan.value = "";
      }
    } else {
      selling_plan.value = "";
    }
  }
}

function inputChangeSubProduct(trigger) {
  //validates quantities for bundle products when the input field is updated
  if (isNaN(trigger.value) || trigger.value == "") {
    trigger.value = 0;
  }

  if (trigger.value > parseInt(trigger.max)) {
    trigger.value = parseInt(trigger.max);
  }

  if (trigger.value < 0) {
    trigger.value = 0;
  }

  if (trigger.value < parseInt(trigger.min)) {
    trigger.value = parseInt(trigger.min);
  }

  const bundleMax = trigger.closest(".lsg-bundle-product-set-list").dataset
    .bundleMax;
  const bundleQuantity = getBundleQuantity(trigger);

  if (bundleQuantity > bundleMax && bundleMax > 0) {
    let bundleDif = bundleQuantity - bundleMax;
    if (trigger.value >= bundleDif) {
      //reduce quantity to stay within bundle max
      trigger.value = trigger.value - bundleDif;
    } else {
      //something went wrong, reset all values to min
      trigger
        .closest(".lsg-bundle-product-set-list")
        .querySelectorAll(".lsg-bundle-product-select-quantity-input")
        .forEach(function (input) {
          input.value = parseInt(input.min);
        });
    }
  }
  updateQuantityDisplay(trigger);
  updateBundlePrice(trigger);
}

function incrementSubProduct(trigger) {
  //validates quantities for the bundle products and updates the input when increment buttons are clicked
  const method = trigger.classList.contains(
    "lsg-bundle-product-select-quantity-minus",
  )
    ? "minus"
    : trigger.classList.contains("lsg-bundle-product-select-quantity-plus")
      ? "plus"
      : "";
  const input = trigger
    .closest(".lsg-bundle-product-select-quantity-wrap")
    .querySelector(".lsg-bundle-product-select-quantity-input");
  const bundleMax = trigger.closest(".lsg-bundle-product-set-list").dataset
    .bundleMax;
  const bundleQuantity = getBundleQuantity(trigger);

  switch (method) {
    case "plus":
      if (input.value >= parseInt(input.max)) {
        //reset to inventory max if over
        input.value = parseInt(input.max);
      } else {
        if (bundleQuantity < parseInt(bundleMax) || parseInt(bundleMax) < 1) {
          input.value++;
        } else {
          //at max bundle quantity, do not change
        }
      }
      updateBundlePrice(trigger);
      break;
    case "minus":
      if (input.value <= parseInt(input.min)) {
        input.value = parseInt(input.min);
      } else if (input.value <= 0) {
        input.value = 0;
      } else {
        input.value--;
      }
      updateBundlePrice(trigger);
      break;
  }
  updateQuantityDisplay(input);
  mirrorQuantityDisplay(input);
}

function mirrorQuantityDisplay(input) {
  // Single shared picker → one input per product; this is a no-op safeguard.
  const picker = getSharedPicker(input);
  if (!picker) return;
  const productID = input.dataset.product;
  const quantity = input.value;
  const productInputs = picker.querySelectorAll(
    '[data-product="' +
      productID +
      '"].lsg-bundle-product-select-quantity-input',
  );
  productInputs.forEach(function (productInput) {
    if (productInput !== input) {
      productInput.value = quantity;
      inputChangeSubProduct(productInput);
    }
  });
}

function updateQuantityDisplay(input) {
  const inputWrap = input.closest(".lsg-bundle-product-select-quantity-wrap");
  if (input.value <= 0) {
    $(inputWrap).addClass("no-quantity");
  } else {
    $(inputWrap).removeClass("no-quantity");
  }
  const inputDisplay = input.parentNode.querySelector(
    ".lsg-bundle-product-select-quantity-input-display",
  );
  if (inputDisplay) {
    inputDisplay.innerHTML = input.value;
  }
}

function parseSaveLabelCents(text) {
  if (!text || text === "none") {
    return 0;
  }
  const cleaned = String(text).replace(/^["']|["']$/g, "");
  const match = cleaned.match(/(\d+(?:\.\d{1,2})?)/);
  if (!match) {
    return 0;
  }
  return Math.round(parseFloat(match[1], 10) * 100);
}

// Subscription price floor (fraction off the regular price). Configurable per
// section via [data-lsg-bundle-wrapper][data-lsg-sub-floor-rate]; falls back to
// SUB_INTERVAL_DISCOUNT_RATE when unset/invalid.
function getSubFloorRate(bundleBlock) {
  const wrapper = bundleBlock && bundleBlock.closest(".lsg-bundle-wrapper");
  const rate = parseFloat(wrapper && wrapper.dataset.lsgSubFloorRate);
  if (!isNaN(rate) && rate >= 0 && rate < 1) {
    return rate;
  }
  return SUB_INTERVAL_DISCOUNT_RATE;
}

function readTierDiscountsMap() {
  const mapEl = document.getElementById("lsg-bundle-tier-discounts");
  if (!mapEl) {
    return null;
  }
  try {
    return JSON.parse(mapEl.textContent);
  } catch (_err) {
    return null;
  }
}

function getTierDiscountCentsForIndex(bundleIndex, wrapper) {
  if (!bundleIndex) {
    return 0;
  }
  const map = readTierDiscountsMap();
  if (map) {
    const mapped = map[bundleIndex] ?? map[String(bundleIndex)];
    if (mapped != null) {
      const cents = parseInt(mapped, 10) || 0;
      if (cents > 0) {
        return cents;
      }
    }
  }
  if (!wrapper) {
    return 0;
  }
  const sizeBtn = wrapper.querySelector(
    '.lsg-bundle-size-select-el[data-bundle-index="' + bundleIndex + '"]',
  );
  if (!sizeBtn) {
    return 0;
  }
  const fromBtn = parseInt(sizeBtn.dataset.tierDiscountCents, 10);
  if (fromBtn > 0) {
    return fromBtn;
  }
  return parseSaveLabelCents(
    window.getComputedStyle(sizeBtn, "::after").content,
  );
}

function getTierDiscountCents(bundleBlock) {
  // Direct per-block value — set by the product-information adapter (lsg-bundle-pi.js) from the
  // active tier button. Takes precedence over the index/JSON lookup used by the legacy section.
  const direct = parseInt(bundleBlock.dataset.tierDiscountCents, 10);
  if (direct > 0) {
    return direct;
  }
  const bundleIndex = bundleBlock.dataset.bundleIndex;
  const wrapper = bundleBlock.closest(".lsg-bundle-wrapper");
  return getTierDiscountCentsForIndex(bundleIndex, wrapper);
}

function syncAllTierDiscounts() {
  const map = readTierDiscountsMap();
  if (!map) {
    return;
  }
  document
    .querySelectorAll(".lsg-bundle-wrapper")
    .forEach(function (wrapper) {
      Object.keys(map).forEach(function (index) {
        const cents = parseInt(map[index], 10) || 0;
        if (cents <= 0) {
          return;
        }
        wrapper
          .querySelectorAll(
            '[data-bundle-index="' + index + '"].lsg-bundle-block',
          )
          .forEach(function (block) {
            block.dataset.tierDiscountCents = String(cents);
          });
        wrapper
          .querySelectorAll(
            '.lsg-bundle-size-select-el[data-bundle-index="' + index + '"]',
          )
          .forEach(function (btn) {
            btn.dataset.tierDiscountCents = String(cents);
          });
      });
    });
}

/**
 * OTP list vs sale totals: Shopify compare-at when set; otherwise tier savings
 * from Stay AI size labels (Save $X) on the size buttons.
 */
function resolveBundleOtpTotals(
  productBaseCents,
  compareAtCents,
  flavorOtpCents,
  tierDiscountCents,
) {
  const subtotal = productBaseCents + flavorOtpCents;

  if (compareAtCents > productBaseCents) {
    const bundleOtpCents = productBaseCents + flavorOtpCents;
    return {
      regularTotalCents: compareAtCents + flavorOtpCents,
      bundleOtpCents: bundleOtpCents,
      discountedBaseCents: productBaseCents,
    };
  }

  if (tierDiscountCents > 0 && subtotal > 0) {
    if (productBaseCents + tierDiscountCents > subtotal) {
      return {
        regularTotalCents:
          productBaseCents + tierDiscountCents + flavorOtpCents,
        bundleOtpCents: subtotal,
        discountedBaseCents: productBaseCents,
      };
    }
    const bundleOtpCents = Math.max(0, subtotal - tierDiscountCents);
    return {
      regularTotalCents: subtotal,
      bundleOtpCents: bundleOtpCents,
      discountedBaseCents: Math.max(0, bundleOtpCents - flavorOtpCents),
    };
  }

  return {
    regularTotalCents: subtotal,
    bundleOtpCents: subtotal,
    discountedBaseCents: productBaseCents,
  };
}

function formatOtpCompareAtPriceHtml(
  currencyFormatter,
  regularTotalCents,
  bundleOtpCents,
) {
  if (regularTotalCents > bundleOtpCents) {
    return (
      '<s class="lsg-bundle-interval-otp-price__compare">' +
      currencyFormatter.format(regularTotalCents / 100) +
      '</s><span class="lsg-bundle-interval-otp-price__total">' +
      currencyFormatter.format(bundleOtpCents / 100) +
      "</span>"
    );
  }
  return currencyFormatter.format(bundleOtpCents / 100);
}

function formatSubIntervalPriceHtml(
  currencyFormatter,
  bundleOtpCents,
  subSubtotalCents,
) {
  if (bundleOtpCents > subSubtotalCents) {
    return (
      '<s class="lsg-bundle-interval-sub-price__compare">' +
      currencyFormatter.format(bundleOtpCents / 100) +
      "</s>" +
      '<span class="lsg-bundle-interval-sub-price__total">' +
      currencyFormatter.format(subSubtotalCents / 100) +
      "</span>"
    );
  }
  return currencyFormatter.format(subSubtotalCents / 100);
}

function updateBundlePrice(trigger) {
  //updates OTP/Sub pricing
  syncAllTierDiscounts();
  const bundleBlock = getBundleBlock(trigger);
  const otpPriceEls = bundleBlock.querySelectorAll(
    ".lsg-bundle-interval-otp-price",
  );
  const subPriceEls = bundleBlock.querySelectorAll(
    ".lsg-bundle-interval-sub-price",
  );
  const curPriceEls = bundleBlock.querySelectorAll(
    "[data-bundle-total], [data-lsg-bundle-parent-product-price]",
  );
  const frequency = bundleBlock.querySelector(
    ".lsg-bundle-interval-frequency-select:not(.is-duplicate) option:checked",
  );
  const productList = getSharedPicker(bundleBlock);
  const hasIntervalSelect = bundleBlock.classList.contains(
    "lsg-bundle--has-interval-select",
  );
  const productBaseCents =
    parseInt(bundleBlock.dataset.productBasePrice, 10) || 0;
  const compareAtCents =
    parseInt(bundleBlock.dataset.productCompareAtPrice, 10) || 0;
  const tierDiscountCents = getTierDiscountCents(bundleBlock);
  let interval = "";
  if (
    bundleBlock.classList.contains("lsg-bundle--only-otp") ||
    bundleBlock.classList.contains("lsg-bundle--otp-selected")
  ) {
    interval = "otp";
  } else if (
    bundleBlock.classList.contains("lsg-bundle--only-sub") ||
    bundleBlock.classList.contains("lsg-bundle--sub-selected")
  ) {
    interval = "sub";
  } else if (hasIntervalSelect) {
    const checkedRadio = bundleBlock.querySelector(
      '.lsg-bundle-interval-select input[type="radio"]:checked',
    );
    if (checkedRadio && checkedRadio.value === "otp") {
      bundleBlock.classList.remove("lsg-bundle--sub-selected");
      bundleBlock.classList.add("lsg-bundle--otp-selected");
      interval = "otp";
    } else {
      if (!checkedRadio) {
        const subRadio = bundleBlock.querySelector(
          '.lsg-bundle-interval-select input[type="radio"][value="sub"]',
        );
        if (subRadio) {
          subRadio.checked = true;
        }
      }
      bundleBlock.classList.remove("lsg-bundle--otp-selected");
      bundleBlock.classList.add("lsg-bundle--sub-selected");
      interval = "sub";
    }
  }
  let flavorOtpCents = 0;
  let flavorSubCents = 0;

  function lineDiscount(price, discountType, discountValue) {
    let discount = 0;
    const dv = parseInt(discountValue, 10) || 0;
    switch (discountType) {
      case "percentage":
        discount = (price * dv) / 100;
        break;
      case "fixed_amount":
        discount = dv;
        break;
      case "price":
        discount = price - dv;
        break;
    }
    return discount;
  }

  if (productList) {
    productList
      .querySelectorAll(".lsg-bundle-product-select-quantity-input")
      .forEach(function (lineInput) {
        const quantity = parseInt(lineInput.value, 10) || 0;
        const price = parseInt(lineInput.dataset.price, 10) || 0;
        const lineOtpCents = quantity * price;
        flavorOtpCents += lineOtpCents;
        if (frequency) {
          const discountType = frequency.dataset.discountType;
          const discountValue = frequency.dataset.discountValue;
          let discount = lineDiscount(price, discountType, discountValue);
          if (discount < 0) {
            discount = 0;
          }
          flavorSubCents += quantity * (price - discount);
        } else {
          flavorSubCents += lineOtpCents;
        }
      });
  }

  const otpTotals = resolveBundleOtpTotals(
    productBaseCents,
    compareAtCents,
    flavorOtpCents,
    tierDiscountCents,
  );
  const regularTotalCents = otpTotals.regularTotalCents;
  const bundleOtpCents = otpTotals.bundleOtpCents;
  const discountedBaseCents = otpTotals.discountedBaseCents;
  const hasSaleOtpTotal =
    bundleOtpCents > 0 && regularTotalCents > bundleOtpCents;

  let subSubtotal;
  if (frequency) {
    const discountType = frequency.dataset.discountType;
    const discountValue = frequency.dataset.discountValue;
    let discount;
    if (hasSaleOtpTotal) {
      discount = lineDiscount(bundleOtpCents, discountType, discountValue);
      if (discount < 0) {
        discount = 0;
      }
      subSubtotal = Math.max(0, bundleOtpCents - discount);
    } else {
      discount = lineDiscount(
        discountedBaseCents,
        discountType,
        discountValue,
      );
      if (discount < 0) {
        discount = 0;
      }
      subSubtotal =
        Math.max(0, discountedBaseCents - discount) + flavorSubCents;
    }
  } else {
    subSubtotal = bundleOtpCents;
  }

  // Ensure the subscription price reflects the advertised "Subscribe & Save"
  // discount even when the selling plan reports a 0% adjustment. This strikes
  // the regular price and shows the discounted total (handled below).
  if (bundleOtpCents > 0) {
    subSubtotal = Math.min(
      subSubtotal,
      Math.round(bundleOtpCents * (1 - getSubFloorRate(bundleBlock))),
    );
  }

  const currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  otpPriceEls.forEach(function (el) {
    el.innerHTML = formatOtpCompareAtPriceHtml(
      currencyFormatter,
      regularTotalCents,
      bundleOtpCents,
    );
  });
  subPriceEls.forEach(function (el) {
    el.innerHTML = formatSubIntervalPriceHtml(
      currencyFormatter,
      bundleOtpCents,
      subSubtotal,
    );
  });
  curPriceEls.forEach(function (el) {
    const isBuyboxDisplay = el.classList.contains("custom_price_display");

    if (interval === "otp") {
      el.textContent = currencyFormatter.format(bundleOtpCents / 100);
    } else if (interval === "sub") {
      if (isBuyboxDisplay && bundleOtpCents > subSubtotal) {
        el.innerHTML =
          '<s class="custom_price_display__compare">' +
          currencyFormatter.format(bundleOtpCents / 100) +
          "</s>" +
          '<span class="custom_price_display__total">' +
          currencyFormatter.format(subSubtotal / 100) +
          "</span>";
      } else {
        el.textContent = currencyFormatter.format(subSubtotal / 100);
      }
    } else {
      el.textContent = currencyFormatter.format(
        (subSubtotal || bundleOtpCents) / 100,
      );
    }
  });
}

function initializeBundle() {
  //loop through bundle blocks
  document
    .querySelectorAll(".lsg-bundle-block")
    .forEach(function (bundleBlock) {
      //set bundle block classes and initial selling_plan input
      const intervalSelect = bundleBlock.querySelector(
        ".lsg-bundle-interval-select",
      );
      const onlyOTP = bundleBlock.querySelector(
        ".lsg-bundle-interval-only-otp",
      );
      const onlySub = bundleBlock.querySelector(
        ".lsg-bundle-interval-only-sub",
      );
      const sellingPlanInput = bundleBlock.querySelector(
        '.lsg-bundle-form input[name="selling_plan"]',
      );
      const frequencySelect = bundleBlock.querySelector(
        ".lsg-bundle-interval-frequency-select:not(.is-duplicate)",
      );
      if (intervalSelect) {
        //has otp/sub selector
        bundleBlock.classList.add("lsg-bundle--has-interval-select");
        let selectedInterval =
          intervalSelect.querySelector(
            'input[name^="bundle_interval_select_"]:checked',
          ) || intervalSelect.querySelector('input[type="radio"][value="sub"]');
        if (!selectedInterval) {
          selectedInterval = intervalSelect.querySelector(
            'input[type="radio"][value="otp"]',
          );
        }
        if (!selectedInterval) {
          // skip interval state; still run price + validation below
        } else {
          switch (selectedInterval.value) {
            case "otp":
              bundleBlock.classList.add("lsg-bundle--otp-selected");
              if (sellingPlanInput) {
                sellingPlanInput.value = "";
              }
              break;
            case "sub":
              bundleBlock.classList.add("lsg-bundle--sub-selected");
              if (sellingPlanInput) {
                sellingPlanInput.value = frequencySelect
                  ? frequencySelect.value
                  : "";
              }
              break;
          }
        }
      } else if (onlyOTP) {
        //has only otp options
        bundleBlock.classList.add("lsg-bundle--only-otp");
        if (sellingPlanInput) {
          sellingPlanInput.value = "";
        }
      } else if (onlySub) {
        //has only sub options
        bundleBlock.classList.add("lsg-bundle--only-sub");
        if (sellingPlanInput) {
          sellingPlanInput.value = frequencySelect ? frequencySelect.value : "";
        }
      }

      //intial enable/disable for quantity increments and submit button
      const initPicker = getSharedPicker(bundleBlock);
      if (initPicker) {
        const firstQtyInput = initPicker.querySelector(
          ".lsg-bundle-product-select-quantity-input",
        );
        if (firstQtyInput) {
          incrementEnableValidation(firstQtyInput);
        }
      }
      checkoutEnableValidation(sellingPlanInput || bundleBlock);
      updateBundlePrice(bundleBlock);
      setTimeout(function () {
        bundleBlock.classList.add("is-initialized");
      }, 500);
    });
  checkParameter();
  syncAllTierDiscounts();
  document.querySelectorAll(".lsg-bundle-block").forEach(function (bb) {
    updateBundlePrice(bb);
  });
  // Point each wrapper's shared picker max at its active tier.
  document
    .querySelectorAll(".lsg-bundle-block.lsg-bundle-block-active")
    .forEach(syncSharedPickerMax);
}

function getBundleQuantity(trigger) {
  //gets the quantity of the current active bundle block product list
  let bundleBlock = getBundleBlock(trigger);
  let quantity = -1;
  let productList = getSharedPicker(bundleBlock);
  if (productList) {
    quantity = 0;
    productList
      .querySelectorAll(".lsg-bundle-product-select-quantity-input")
      .forEach(function (input) {
        quantity = quantity + parseInt(input.value);
      });
  }
  return quantity;
}

function getBundleQuantityByChild(trigger) {
  const productSetList = trigger.closest(".lsg-bundle-product-set-list");
  let quantity = -1;
  if (productSetList) {
    quantity = 0;
    productSetList
      .querySelectorAll(".lsg-bundle-product-select-quantity-input")
      .forEach(function (input) {
        quantity = quantity + parseInt(input.value);
      });
  }
  return quantity;
}

function getBundleInterval(trigger) {
  //checks if the bundle is set to display OTP or suscription options
  let bundleBlock = getBundleBlock(trigger);
  if (bundleBlock.classList.contains("lsg-bundle--has-interval-select")) {
    if (bundleBlock.classList.contains("lsg-bundle--otp-selected")) {
      return "otp";
    }
    if (bundleBlock.classList.contains("lsg-bundle--sub-selected")) {
      return "sub";
    }
  }
  if (bundleBlock.classList.contains("lsg-bundle--only-otp")) {
    return "otp";
  }
  if (bundleBlock.classList.contains("lsg-bundle--only-sub")) {
    return "sub";
  }
  return "err";
}

function getBundleBlock(trigger) {
  // Flavor picker lives in the shared media column (not inside any tier block),
  // so a trigger there resolves to the ACTIVE tier block.
  return (
    trigger.closest(".lsg-bundle-block") ||
    (trigger.closest(".lsg-bundle-wrapper") || document).querySelector(
      ".lsg-bundle-block.lsg-bundle-block-active",
    )
  );
}

/** The single shared flavor picker set-list (rendered once per wrapper). */
function getSharedPicker(ctx) {
  const wrapper =
    (ctx && ctx.closest && ctx.closest(".lsg-bundle-wrapper")) ||
    document.querySelector(".lsg-bundle-wrapper");
  return wrapper ? wrapper.querySelector(".lsg-bundle-product-set-list") : null;
}

/** Point the shared picker's bundle max at the active tier (mirrors the per-tier set-list value). */
function syncSharedPickerMax(bundleBlock) {
  if (!bundleBlock) return;
  const picker = getSharedPicker(bundleBlock);
  if (!picker) return;
  const max =
    bundleBlock.dataset.subBundleMax || bundleBlock.dataset.otpBundleMax;
  if (max != null && max !== "") {
    picker.dataset.bundleMax = max;
  }
}

/**
 * Re-fit a block's own selection to its current tier max — for the product-information composition
 * where ONE block's tier (quantity) changes in place (no separate source/target block, so the legacy
 * carrySelectedProductsToBundle never runs). Call AFTER syncSharedPickerMax + the block's max data is
 * updated. Going DOWN: trims the surplus, keeping the first N flavors that fit the new lower max.
 * Always: re-syncs the shared picker inputs + per-flavor card counts + (re-enables) the +/- buttons
 * + price + the selected-summary slot tiles. Going UP just re-enables the + buttons (nothing to trim).
 */
function refitBundleSelection(bundleBlock) {
  if (!bundleBlock) return;
  const bundleIndex0 = getBundleBlockIndex0(bundleBlock);
  if (!selectedProducts[bundleIndex0]) selectedProducts[bundleIndex0] = [];
  const max = getBundleMax(bundleBlock);
  if (max > 0 && selectedProducts[bundleIndex0].length > max) {
    selectedProducts[bundleIndex0] = selectedProducts[bundleIndex0].slice(
      0,
      max,
    );
  }
  syncSelectedProductsToBundleInputs(bundleBlock);
  updateSelectedProductGUI(bundleBlock);
}
window.refitBundleSelection = refitBundleSelection;

/** Index among `.lsg-bundle-block` siblings only (wrapper may contain other nodes e.g. gallery highlights). */
function getBundleBlockIndex0(bundleBlock) {
  if (!bundleBlock || !bundleBlock.parentNode) return 0;
  return Array.from(
    bundleBlock.parentNode.querySelectorAll(":scope > .lsg-bundle-block"),
  ).indexOf(bundleBlock);
}

function getGuid() {
  let d = new Date().getTime();
  let d2 = (performance && performance.now && performance.now() * 1000) || 0;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    let r = Math.random() * 16;
    if (d > 0) {
      r = ((d + r) % 16) | 0;
      d = Math.floor(d / 16);
    } else {
      r = ((d2 + r) % 16) | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c == "x" ? r : (r & 0x7) | 0x8).toString(16);
  });
}

//Event Listeners
if (document.addEventListener) {
  window.addEventListener(
    "pageshow",
    function (event) {
      if (
        event.persisted ||
        performance.getEntriesByType("navigation")[0].type === "back_forward"
      ) {
        document
          .querySelectorAll(".lsg-bundle-product-select-quantity-input")
          .forEach(function (input) {
            input.value = 0;
            inputChangeSubProduct(input);
            incrementEnableValidation(input);
            checkoutEnableValidation(input);
          });
      }
    },
    false,
  );
}

function lsgBundleBoot() {
document
  .querySelectorAll("[data-bundle-builder-selected-product-remove-button]")
  .forEach(function (removeButton) {
    if (removeButton.dataset.lsgBound) return;
    removeButton.dataset.lsgBound = "1";
    removeButton.addEventListener("click", function (e) {
      e.preventDefault();
      const triggeredProductWrapper = e.target.closest(
        "[data-bundle-builder-selected-variant-id]",
      );
      productSelectionButtonClicked = true;
      productSelectionIndex =
        triggeredProductWrapper.getAttribute("data-index");
      const variantID = triggeredProductWrapper.getAttribute(
        "data-bundle-builder-selected-variant-id",
      );
      const picker = getSharedPicker(e.currentTarget);
      const bundleProduct = picker
        ? picker.querySelector(
            `[data-lsg-bundle-variant-select-id='${variantID}']`,
          )
        : null;
      if (!bundleProduct) return;
      const bundleProductDecrement = bundleProduct.querySelector(
        ".lsg-bundle-product-select-quantity-minus",
      );

      // Animate the clicked tile out, THEN fire the real decrement. The globals set just above stay
      // valid for the deferred decrement so it still splices the right index — and because
      // productSelectionButtonClicked is true, the quantity-minus handler below won't re-animate.
      const bundleBlock = getBundleBlock(e.currentTarget);
      animateBundleSlotRemoval(
        bundleBlock,
        parseInt(productSelectionIndex, 10),
        function () {
          bundleProductDecrement.click();
        },
      );
    });
  });

document
  .querySelectorAll(".lsg-bundle-product-select-quantity-increment")
  .forEach(function (incrementButton) {
    if (incrementButton.dataset.lsgBound) return;
    incrementButton.dataset.lsgBound = "1";
    incrementButton.addEventListener("click", function (e) {
      e.preventDefault();
      const trigger = e.currentTarget;
      playQtyTilt(trigger);

      const apply = function () {
        incrementSubProduct(trigger);
        buildSelectedProductArray(trigger);
        incrementEnableValidation(trigger);
        checkoutEnableValidation(trigger);
        setUrl(trigger);
      };

      // A DIRECT picker decrement (minus) animates the same tile buildSelectedProductArray will
      // splice — the LAST slot holding this variant — then applies. The X-button path sets
      // productSelectionButtonClicked first (and already animated), so it skips straight to apply.
      const isMinus = trigger.classList.contains(
        "lsg-bundle-product-select-quantity-minus",
      );
      if (isMinus && !productSelectionButtonClicked) {
        const bundleBlock = getBundleBlock(trigger);
        const bundleIndex0 = getBundleBlockIndex0(bundleBlock);
        const wrapper = trigger.closest(".lsg-bundle-product-select-wrapper");
        const variantID = wrapper
          ? wrapper.getAttribute("data-lsg-bundle-variant-select-id")
          : null;
        const removalIndex = (selectedProducts[bundleIndex0] || []).findLastIndex(
          (p) => p.selectedVariantId == variantID,
        );
        if (removalIndex >= 0) {
          // Drop the stepper number/price right away so the count reflects the tap; the summary
          // tile still animates out over LSG_SLOT_REMOVE_MS, then we splice the array + re-validate.
          // (incrementSubProduct only touches the picker input/display/price — independent of the
          // selectedProducts splice in buildSelectedProductArray — so it's safe to run early.)
          incrementSubProduct(trigger);
          animateBundleSlotRemoval(bundleBlock, removalIndex, function () {
            buildSelectedProductArray(trigger);
            incrementEnableValidation(trigger);
            checkoutEnableValidation(trigger);
            setUrl(trigger);
          });
          return;
        }
      }
      apply();
    });
  });
document
  .querySelectorAll(".lsg-bundle-product-select-quantity-input")
  .forEach(function (input) {
    if (input.dataset.lsgBound) return;
    input.dataset.lsgBound = "1";
    input.addEventListener("change", function (e) {
      inputChangeSubProduct(e.currentTarget);
      incrementEnableValidation(e.currentTarget);
      checkoutEnableValidation(e.currentTarget);
    });
  });
document
  .querySelectorAll(
    '.lsg-bundle-interval-select input[name^="bundle_interval_select_"]',
  )
  .forEach(function (intervalSelector) {
    if (intervalSelector.dataset.lsgBound) return;
    intervalSelector.dataset.lsgBound = "1";
    intervalSelector.addEventListener("change", function (e) {
      updateInterval(e.currentTarget);
      checkoutEnableValidation(e.currentTarget);
      setUrl(e.currentTarget);
    });
  });
document
  .querySelectorAll(".lsg-bundle-interval-frequency-select")
  .forEach(function (frequencySelect) {
    if (frequencySelect.dataset.lsgBound) return;
    frequencySelect.dataset.lsgBound = "1";
    frequencySelect.addEventListener("change", function (e) {
      const trigger = e.currentTarget;
      updateFrequency(e.currentTarget);
      setUrl(e.currentTarget);
    });
  });
document.querySelectorAll("[data-lsg-bundle-atc]").forEach((bundleATC) => {
  if (bundleATC.dataset.lsgBound) return;
  bundleATC.dataset.lsgBound = "1";
  bundleATC.addEventListener("click", function (e) {
    e.preventDefault();
    if (e.currentTarget.classList.contains("disabled")) {
      //scroll to top of the bundle block
      const announcementOffset =
        parseInt(
          document.body.style
            .getPropertyValue("--announcement-offset")
            .replace("px", ""),
        ) || 0;
      const headerOffset =
        parseInt(
          document.body.style
            .getPropertyValue("--header-offset")
            .replace("px", ""),
        ) || 0;
      const offset = announcementOffset + headerOffset;
      const bundleBlock = getBundleBlock(e.currentTarget);
      window.scrollTo({
        top: bundleBlock.offsetTop - offset,
        behavior: "smooth",
      });
    } else {
      addToCart(e.currentTarget);
    }
  });
});
document
  .querySelectorAll(".lsg-bundle-size-select-el")
  .forEach(function (bundleSelector) {
    // Tier buttons of the product-information composition are driven by lsg-bundle-pi.js, not the
    // legacy setActiveBundle (which toggles 3 .lsg-bundle-block by index). Skip those here.
    if (bundleSelector.hasAttribute("data-lsg-tier")) return;
    if (bundleSelector.dataset.lsgBound) return;
    bundleSelector.dataset.lsgBound = "1";
    bundleSelector.addEventListener("click", function (e) {
      e.preventDefault();
      setActiveBundle(e.currentTarget);
    });
  });

document
  .querySelectorAll("[data-lsg-bundle-sticky-summary-toggle]")
  .forEach(function (toggleBtn) {
    if (toggleBtn.dataset.lsgBound) return;
    toggleBtn.dataset.lsgBound = "1";
    toggleBtn.addEventListener("click", function () {
      const wrap = toggleBtn.closest(".lsg-bundle-sticky-summary-wrap");
      if (!wrap) return;
      const collapsed = wrap.classList.toggle(
        "lsg-bundle-sticky-summary-wrap--collapsed",
      );
      toggleBtn.setAttribute("aria-expanded", collapsed ? "false" : "true");
      const expandLab = toggleBtn.getAttribute("data-label-expand") || "";
      const collapseLab = toggleBtn.getAttribute("data-label-collapse") || "";
      toggleBtn.setAttribute("aria-label", collapsed ? expandLab : collapseLab);
    });
  });

  //Run initialize
  initializeBundle();
} // end lsgBundleBoot

// Boot now, and re-boot when the Theme Editor re-renders the bundle's section. The editor swaps
// the section DOM without re-running this deferred script, so without this the flavor select /
// remove / ATC handlers go dead after every block edit. Per-element data-lsgBound guards keep a
// re-boot from double-binding any element that survived.
lsgBundleBoot();
document.addEventListener("shopify:section:load", function (e) {
  if (
    e.target &&
    e.target.querySelector &&
    (e.target.querySelector("[data-lsg-tier-chooser]") ||
      e.target.querySelector(".lsg-bundle-block") ||
      e.target.querySelector(".lsg-bundle-product-set-list"))
  ) {
    lsgBundleBoot();
  }
});

// Safety: on the deferred first pass the shared flavor picker can be present but not yet
// wired (the +/- "ADD" buttons render disabled and are enabled by incrementEnableValidation
// during init). Re-run ONLY the button-enable pass once the page is fully loaded — NOT the
// full initializeBundle, which would re-run checkParameter() and re-apply the URL selection,
// duplicating the selected-flavor chips.
function lsgEnablePickerButtons() {
  document
    .querySelectorAll(".lsg-bundle-product-set-list")
    .forEach(function (picker) {
      const firstInput = picker.querySelector(
        ".lsg-bundle-product-select-quantity-input",
      );
      if (firstInput) {
        incrementEnableValidation(firstInput);
      }
    });
}
if (document.readyState !== "complete") {
  window.addEventListener("load", lsgEnablePickerButtons, { once: true });
}

const bundleObserver = new IntersectionObserver(([entry]) => {
  const bundleBlock = entry.target.closest(".lsg-bundle-block");
  if (bundleBlock) {
    bundleBlock.classList.remove("summary-is-below");
    bundleBlock.classList.remove("summary-is-above");
    bundleBlock.classList.remove("summary-is-visible");

    if (entry.isIntersecting) {
      // is visible
      bundleBlock.classList.add("summary-is-visible");
      return;
    } else if (entry.boundingClientRect.top > 0) {
      // item is below view
      bundleBlock.classList.add("summary-is-below");
    } else {
      // item is above view
      bundleBlock.classList.add("summary-is-above");
    }
  }
});
const buyboxes = document.querySelectorAll(".lsg-bundle-summary-block");
buyboxes.forEach((buybox) => {
  bundleObserver.observe(buybox);
});

const bottomObserver = new IntersectionObserver(
  ([entry]) => {
    const bundleBlocks = document.querySelectorAll(".lsg-bundle-block");
    if (entry.isIntersecting) {
      bundleBlocks.forEach((bundleBlock) => {
        bundleBlock.classList.add("is-scroll-bottom");
      });
    } else {
      bundleBlocks.forEach((bundleBlock) => {
        bundleBlock.classList.remove("is-scroll-bottom");
      });
    }
  },
  {
    threshold: 1,
  },
);
const subFooter = document.querySelector(".io-sub-footer");
if (subFooter) {
  bottomObserver.observe(subFooter);
}
